<template>
<!-- Modal -->
  <div class="modale_box" :class="{'opened': modalFlag }" aria-hidden="true" @click.self="modalClose">
    <div class="modale">
      <div class="modal-dialog">
        <div class="modal-header">
          <a href="#" class="btn-close closemodale" @click.prevent="modalClose" aria-hidden="true">&times;</a>
        </div>
        <div class="modal-body">
          <img :src="img" style="width: 100%;" alt="">
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
<!-- /Modal -->
</template>
<script>
export default {
  name: 'popinfo',
  props: ["modalFlag", "img"],
  methods: {
    modalClose(){
      this.$emit('closeModal')
    }
  },
}
</script>
<style>
.modale{position: relative;}
.btn-close {
  color: #aaaaaa;
  font-size: 20px;
  text-decoration: none;
  padding:10px;
  position: absolute;
  right: 7px;
  top: -8px;
}
.btn-close:hover {
  color: #919191;
}
.modale_box {
  width: calc(100% + 17px);
  height: 100%;
  max-height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  overflow: auto;
  z-index: 999;
}
.opened.modale_box {
  display: block;
}
.opened .modal-dialog {
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
.modal-dialog {
  background: #fefefe;
  border: #333333 solid 0px;
  border-radius: 25px;
  margin: auto;
  text-align: center;
  position: fixed;
  left:50%;
  top: 50%;
  z-index: 999;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-out;
  max-height: 90vh;
  overflow: auto;
  -ms-overflow-style: none;
}
.modal-dialog::-webkit-scrollbar{ display: none;}
.modal-body {
  padding: 7px 14px;
}
.modal-body input {
  width: 200px;
  padding: 8px;
  border: 1px solid #ddd;
  color: #888;
  outline: 0;
  font-size: 14px;
  font-weight: bold;
}
.modal-header,
.modal-footer {
  padding: 10px 20px;
}
/* .modal-header {
  border-bottom: #eeeeee solid 1px;
} */
.modal-header>div{display: flex; justify-content: left; align-content: center;}
.modal-header h1 {
  margin: 0 10px;
  display: flex;
  align-items: center;
}

/* modal內容 */
.modal-body>div:nth-of-type(1)>h2{ margin: 5px auto 10px;}
.modal-body>div:nth-of-type(1)>p:nth-of-type(1){
  font-size: 22px;
  font-weight: 600;
  margin: 5px 0;
}
.modal-body>div:nth-of-type(1)>img{
  width: 45%;
}
.modal-body>div:nth-of-type(1)>p:nth-of-type(2){
  font-size: 20px;
  margin: 5px 0;
}
.modal-body>div:nth-of-type(2)>p{
  display: inline-block;
  font-size: 18px;
  border-radius: 20px;
  background-color: #333333;
  color: #ffffff;
  padding: 5px 15px;
}
.modal-body>div:nth-of-type(2)>ol{
  text-align: left;
  padding: 0 0 0 21px
}
.modal-body>div:nth-of-type(2) li{
  line-height: 1.6;
}
@media(max-width: 768px){
  .modal-body>div:nth-of-type(1)>h2{
    font-size: 1.2rem;
  }
  .modal-body>div:nth-of-type(1)>p:nth-of-type(1),
  .modal-body>div:nth-of-type(1)>p:nth-of-type(2){
    font-size: 18px;
  }
}
@media (max-width: 450px) {
  .modal-body>div:nth-of-type(1)>img{width: 80%;}
}
</style>